import { useEffect } from 'react'
export function useOutsideClickedCallback(ref, callback): void {
  useEffect(() => {
    function handleClickOutside(event): void {
      if (ref.current && !ref.current.contains(event.target)) {
        callback()
      }
    }

    document.addEventListener('mousedown', handleClickOutside)
    return () => {
      document.removeEventListener('mousedown', handleClickOutside)
    }
  }, [ref])
}
